/* @flow weak */
import './Footer.scss'
import React from 'react'
import { defineMessages, injectIntl } from 'react-intl'
import { Grid, Row, Col } from 'react-bootstrap'

const messages = defineMessages({
  footerCooperation: {
    id: 'footer.cooperation',
    defaultMessage: 'Vytvořeno ve spolupráci s VIRTII',
  },
  company: {
    id: 'footer.company',
    defaultMessage: '© 2017 Yum Group s.r.o.',
  },
})

const Footer = ({ intl }) => (
  <footer className="footer">
    <Grid>
      <Row>
        <Col sm={4}>
          {intl.formatMessage(messages.company)}
        </Col>
        <Col sm={8}>
          <a href="http://virtii.com" target="_blank" className="virtii">
          {intl.formatMessage(messages.footerCooperation)}
          </a>
        </Col>
      </Row>
    </Grid>
  </footer>
)
export default injectIntl(Footer)



// WEBPACK FOOTER //
// ./src/browser/app/Footer.js